import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { ADJUST_PAYMENT_ANALYTICS_ACTIONS } from './adjust-payment-analytics.actions';
import { AdjustPaymentAnalyticsMessages } from './adjust-payment-analytics.constants';
import {
  AdjustPaymentPageLoad,
  shortPaymentModalTransformer,
} from './adjust-payment-analytics.transformers';

@Injectable({
  providedIn: 'root',
})
export class AdjustPaymentAnalyticsService {
  constructor(private store: Store) {}

  private mapDataObjectToShortPayModal(event: string) {
    return {
      capability: AdjustPaymentAnalyticsMessages.capability,
      event: event,
      modalName: AdjustPaymentAnalyticsMessages.shortPayModalName,
    };
  }

  trackPageLoad(): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          capability: AdjustPaymentAnalyticsMessages.capability,
          event: AdjustPaymentAnalyticsMessages.pageLoadedEvent,
          pageName: AdjustPaymentAnalyticsMessages.pageName,
        },
        transformFunc: AdjustPaymentPageLoad,
      },
    };
    this.store.dispatch(
      ADJUST_PAYMENT_ANALYTICS_ACTIONS.trackPageLoad({ tracking }),
    );
  }

  trackCloseShortPayModal(): void {
    const tracking: Tracking = {
      analytics: {
        data: this.mapDataObjectToShortPayModal(
          AdjustPaymentAnalyticsMessages.modalCloseEvent,
        ),
        transformFunc: shortPaymentModalTransformer,
      },
    };
    this.store.dispatch(
      ADJUST_PAYMENT_ANALYTICS_ACTIONS.trackClosureShortPayModal({ tracking }),
    );
  }

  trackOpenShortPayModal(): void {
    const tracking: Tracking = {
      analytics: {
        data: this.mapDataObjectToShortPayModal(
          AdjustPaymentAnalyticsMessages.modalOpenEvent,
        ),
        transformFunc: shortPaymentModalTransformer,
      },
    };
    this.store.dispatch(
      ADJUST_PAYMENT_ANALYTICS_ACTIONS.trackOpeningShortPayModal({ tracking }),
    );
  }

  trackSubmitShortPayModal(shortPayReason: string): void {
    const tracking: Tracking = {
      analytics: {
        data: {
          ...this.mapDataObjectToShortPayModal(
            AdjustPaymentAnalyticsMessages.modalSubmittedEvent,
          ),
          shortPayReason,
        },
        transformFunc: shortPaymentModalTransformer,
      },
    };
    this.store.dispatch(
      ADJUST_PAYMENT_ANALYTICS_ACTIONS.trackSubmittingShortPayModal({
        tracking,
      }),
    );
  }
}
